<template>
    <div class="contacts">
        <div class="contacts__info">
            <h2 class="page__title title title--m">Контакты</h2>
            <span class="contacts__info-item">Центральный офис: <span class="contacts__info-value">Москва, Кузнецовская, д 1</span></span>
            <span class="contacts__info-item">Телефон: <span class="contacts__info-value">8 (800) 000-00-00</span></span>
            <span class="contacts__info-item">E-mail: <span class="contacts__info-value">info@antiqbay.com</span></span>
            <span class="contacts__info-item">Адреса офисов:
                <button class="btn btn--link contacts__info-button" @click="visible = true">Открыть карту филиалов</button>
            </span>
        </div>
        <contacts-map></contacts-map>
        <el-dialog
            class="popup"
            :width="windowWidth > 1200 ? '1170px' : '95%'"
            :append-to-body="true"
            :show-close="false"
            :visible.sync="visible">
            <button class="btn popup__close" @click.prevent="visible = false">
                <i class="el-icon-close"></i>
            </button>
            <offices></offices>
        </el-dialog>
    </div>
</template>

<script>
    import Offices from '../office/Offices'
    import ContactsMap from "./modules/ContactsMap";

    export default {
        name: "contacts",
        components: {ContactsMap, Offices},
        data: () => ({
            visible: false,
        }),
    }
</script>
